import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from '@src/auth/guard';
// layouts
import DashboardLayout from '@layouts/dashboard';
// components
import { LoadingScreen } from '@components/loading-screen';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('@pages/users/list'));

// ----------------------------------------------------------------------

export const usersRoutes = [
  {
    path: 'users',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [{ element: <IndexPage />, index: true }],
  },
];
